import { render } from "./BirthDate.vue?vue&type=template&id=7673cb1c&scoped=true"
import script from "./BirthDate.vue?vue&type=script&lang=js"
export * from "./BirthDate.vue?vue&type=script&lang=js"

import "./BirthDate.vue?vue&type=style&index=0&id=7673cb1c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\playerpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7673cb1c"]])

export default __exports__